/* ===== TAHOE GLOW — Main JS ===== */

// ─── Stars
(function () {
  const container = document.getElementById('stars');
  if (!container) return;
  for (let i = 0; i < 120; i++) {
    const s = document.createElement('div');
    s.className = 'star';
    const size = Math.random() * 2.5 + 0.5;
    s.style.cssText = `width:${size}px;height:${size}px;left:${Math.random() * 100}%;top:${Math.random() * 70}%;--dur:${2 + Math.random() * 4}s;animation-delay:${Math.random() * 5}s;`;
    container.appendChild(s);
  }
})();

// ─── Scroll reveal
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// ─── Mobile nav
const hamburger = document.querySelector('.nav-hamburger');
const navLinks = document.querySelector('.nav-links');
if (hamburger && navLinks) {
  hamburger.addEventListener('click', () => navLinks.classList.toggle('open'));
}

// ─── Color preset scenes
const scenes = {
  christmas: { color: '#e8001a', color2: '#00aa1a', alt: true },
  july4:     { color: '#ff3300', color2: '#0033cc', alt: true },
  gameday:   { color: '#ff6600', color2: '#0000aa', alt: false },
  halloween: { color: '#ff6600', color2: '#9900cc', alt: false },
  accent:    { color: '#00d4ff', color2: '#1a6aff', alt: false },
  tahoe:     { color: '#00d4ff', color2: '#00aaff', alt: false },
  custom:    { color: '#ff00cc', color2: '#ffee00', alt: true },
};

window.setScene = function (key) {
  const s = scenes[key];
  const lights = document.querySelectorAll('#roofLights circle');
  const eave = document.querySelector('#eaveLights line');
  const glow = document.querySelector('#roofGlow');
  const ground = document.querySelector('#groundGlow');
  if (!lights.length) return;
  lights.forEach((c, i) => c.setAttribute('fill', (s.alt && i % 2 === 0) ? s.color2 : s.color));
  if (eave) eave.setAttribute('stroke', s.color);
  if (glow) glow.setAttribute('stroke', s.color);
  if (ground) ground.setAttribute('fill', s.color);
};

// ─── Services tab switching
const commercialServices = [
  { icon: '🏢', title: 'Building Facade', desc: 'Architectural LED wraps for storefronts, hotels, and commercial properties.' },
  { icon: '🅿️', title: 'Parking Lot Lighting', desc: 'Energy-efficient LED systems for safe, bright parking areas.' },
  { icon: '🍽️', title: 'Restaurant & Hospitality', desc: 'Create ambiance and attract customers with branded color themes.' },
  { icon: '🏨', title: 'Hotel & Resort', desc: 'Seasonal and event lighting managed from a single dashboard.' },
  { icon: '🏗️', title: 'New Construction', desc: 'Spec our systems in during construction for seamless integration.' },
  { icon: '🎪', title: 'Event & Venue', desc: 'Dynamic lighting for events, concerts, and special occasions.' },
  { icon: '🔐', title: 'Commercial Security', desc: 'Motion-triggered zone lighting integrated with your security system.' },
  { icon: '🌐', title: 'Signage Accent', desc: 'Backlight your signage to maximize after-dark visibility.' },
];
const residentialServices = [
  { icon: '🏡', title: 'Roofline Lighting', desc: 'Full eave-to-peak permanent LED systems for every architectural line.' },
  { icon: '🌲', title: 'Landscape Lighting', desc: 'Trees, walkways, and gardens — beautifully lit.' },
  { icon: '🔦', title: 'Security Lighting', desc: 'Motion-activated zones that flood your property with light.' },
  { icon: '🎇', title: 'Holiday Lighting', desc: 'Christmas to Halloween with a single tap. No ladders.' },
  { icon: '🏈', title: 'Game Day Lighting', desc: 'Show your team colors on game night, instantly.' },
  { icon: '☀️', title: 'Accent Lighting', desc: 'Architectural highlights and soffit washing for curb appeal.' },
  { icon: '🌿', title: 'Patio & Pergola', desc: 'Permanent overhead and perimeter lighting for outdoor living.' },
  { icon: '🛤️', title: 'Pathway Lighting', desc: 'Elegant, low-profile pathway LEDs for safe navigation.' },
];

window.switchTab = function (btn, type) {
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const grid = document.getElementById('serviceGrid');
  if (!grid) return;
  const data = type === 'commercial' ? commercialServices : residentialServices;
  grid.innerHTML = data.map(s => `<div class="service-card"><div class="service-card-icon">${s.icon}</div><h4>${s.title}</h4><p>${s.desc}</p></div>`).join('');
};

// ─── Gallery filter
window.filterGallery = function (btn, category) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.gallery-masonry-item').forEach(item => {
    if (category === 'all' || item.dataset.category === category) {
      item.style.display = 'block';
    } else {
      item.style.display = 'none';
    }
  });
};

/* ─── PRESET PHOTO SWITCHER ─── */
(function () {
  const photos = document.querySelectorAll('.preset-photo');
  if (!photos.length) return;

  // Show the first photo on load
  let first = photos[0];
  first.classList.add('active');

  const _origSetScene = window.setScene;
  window.setScene = function (key) {
    if (typeof _origSetScene === 'function') _origSetScene(key);
    const match = document.querySelector('.preset-photo[data-scene="' + key + '"]');
    if (match) {
      photos.forEach(p => p.classList.remove('active'));
      match.classList.add('active');
    }
  };
})();

/* ─── SERVICES: show Residential by default on load ─── */
(function () {
  const grid = document.getElementById('serviceGrid');
  if (!grid) return;
  // Only auto-fill if the grid is empty (hasn't been populated server-side)
  if (grid.children.length === 0) {
    const firstTab = document.querySelector('.tab-btn');
    if (firstTab && typeof window.switchTab === 'function') {
      window.switchTab(firstTab, 'residential');
    }
  }
})();